import React from "react";

const SwitchButton = ({ isChecked, handleSwitchToggle }) => {
  return (
    <div className="d-flex justify-content-center">
      <label className="switchCollapse">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleSwitchToggle}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default SwitchButton;
